"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _SimpleWrapper = _interopRequireDefault(require("lead-flows-ui/components/common/SimpleWrapper"));

var _default = _react.default.createClass({
  displayName: "DynoEditorSubheader",
  propTypes: {
    children: _react.default.PropTypes.node.isRequired,
    meta: _react.default.PropTypes.string,
    helperInfo: _react.default.PropTypes.node
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        meta = _this$props.meta,
        helperInfo = _this$props.helperInfo;
    return _react.default.createElement(_UIFormControl.default, {
      className: "private-toggle-group",
      label: children,
      help: meta,
      tooltip: helperInfo
    }, _react.default.createElement(_SimpleWrapper.default, null));
  }
});

exports.default = _default;
module.exports = exports.default;